import { useUpdateVendorMutation } from "generated/graphql";
import { useTranslation } from "react-i18next";
import { useSnack } from "hooks/useSnack";

type Updates = Record<string, string | boolean | number | null>;

/**
 * Saves vendor profile fields. Resolves false on a rejected save so
 * ProfileEditButton puts the old value back.
 */
export const useVendorFieldSave = () => {
  const showSnack = useSnack();
  const { t } = useTranslation("profile");
  const [, updateVendor] = useUpdateVendorMutation();

  return async (updates: Updates): Promise<boolean> => {
    const response = await updateVendor({ options: updates });
    if (response.error || response.data?.updateVendor.errors) {
      showSnack(
        response.data?.updateVendor.errors?.[0].message ??
          response.error?.message ??
          t("error"),
        "error",
      );
      return false;
    }

    // e.g. a renamed business that no longer matches its linked Google listing
    const warning = response.data?.updateVendor.warnings?.[0]?.message;
    showSnack(warning ?? t("saved"), warning ? "warning" : "success");
    return true;
  };
};
